var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0709 4.643C16.3964 4.31756 16.7475 3.90282 16.4221 3.57738C16.0967 3.25194 15.6821 3.60324 15.3566 3.92868L9.99948 9.28584L4.64236 3.92871C4.31692 3.60328 3.90236 3.25198 3.57692 3.57742C3.25149 3.90285 3.60266 4.3176 3.9281 4.64303L9.2852 10.0001L3.92806 15.3573C3.60262 15.6827 3.25149 16.0971 3.57692 16.4226C3.90236 16.748 4.31692 16.397 4.64235 16.0716L9.9995 10.7144L15.3567 16.0716C15.6821 16.397 16.0967 16.748 16.4221 16.4226C16.7475 16.0972 16.3964 15.6828 16.071 15.3573L10.7138 10.0001L16.0709 4.643Z",
    fill: "#434647",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.92ce8f2d186c39aea6a6db9d9dfd41ef.svg";
export { ForwardRef as ReactComponent };